module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/btn_2_new_pc_b47381415464480c315f9326d5e4e2bf.png";